
import {Bank} from "@/models/base";
import Vue from "vue";
import BankBalance from "@/models/base/bank-balance";
import {BankService} from "@/services/bank-service";
import AppSelectBankType from "./SelectBankType.vue";
import AppLabel from "@/components/common/InfoInput.vue";
import AppSelectBankKind from "./SelectBankKind.vue";


export default Vue.extend({
	data(){
		return{
			balances: [] as BankBalance[],

		};
	},
	props: {
		bank: {
			type: Object as ()=>Bank,
			required: true
		}

	},
	computed: {

	},
	watch: {

	},
	methods: {

	},
	mounted(){

	},
	async created(){
		this.balances = await BankService.getAllBalances();
	},
	components: {
		AppSelectBankType,
		AppLabel,
		AppSelectBankKind
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
